import styled from 'styled-components';
import {
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    PRIMARY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    SMALL_TEXT_PX,
    GRAY_FONT_COLOR
} from 'src/styles/fonts/MCFontConstants';

export const ConsignedTableContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: visible;
    position: relative;
    margin: ${({isMobile}) => (isMobile ? '0px' : '0px 5px')};
    box-sizing: border-box;

    &.desktop-view {
        > div,
        > div > div {
            display: flex;
            flex-direction: row;
            min-height: 0;
            overflow: visible;
        }
    }

    &.mobile-view {
        height: 100%;
        overflow: visible;
        
        > div {
            display: flex;
            flex-direction: column;
            overflow: visible;
            overflow-y: auto;
        }
    }

    .p-datatable {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: visible;
    }

    .p-datatable-scrollable-wrapper,
    .p-datatable-scrollable-view {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .p-datatable-scrollable-header {
        flex-shrink: 0;
    }

    .p-datatable table,
    .p-datatable-scrollable-header-table,
    .p-datatable-scrollable-body-table {
        width: 100% !important;
        table-layout: fixed !important;
    }

    .p-datatable-wrapper {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
    }

    .p-datatable .p-datatable-scrollable-body {
        max-height: calc(100vh - 360px) !important;
    }

    .p-datatable .p-paginator-bottom {
        flex-shrink: 0;
        margin-top: 12px;
        background: #ffffff;
        box-shadow: 0px 0px 6px #00000029 !important;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        min-height: 48px;
    }

    .p-datatable .p-datatable-thead > tr{
        height: 68px;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
    }

    .p-datatable .p-datatable-tbody > tr {
        padding: 8px 16px;
        height: 48px;
        border-radius: 0;
    }

    .p-datatable .p-datatable-thead > tr > th,
    .p-datatable .p-datatable-tbody > tr > td {
        box-sizing: border-box;
    }

    .p-datatable .p-datatable-thead > tr > th {
        height: 68px;
        padding: 0 !important;
        vertical-align: middle;
        background: #ffffff;
    }
    .p-datatable .p-datatable-tbody > tr > td {
        height: 48px;
        padding: 8px 0px 8px 2px !important;
        vertical-align: middle;
        border-radius: 0;
    }

    .p-datatable .p-datatable-thead > tr > th {
        font-family: ${FONT_FAMILY_DEMI};
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: ${GRAY_FONT_COLOR};
    }

    .p-datatable .p-column-title {
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
    }
    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover{
        color: ${GRAY_FONT_COLOR};
    }

    @media (min-width: 768px) and (min-width: 850px) and (orientation: landscape) {
        .p-datatable .p-sortable-disabled .p-column-title, .p-datatable .p-sortable-column .p-column-title {
            width: auto;
        }
    }

    .p-datatable .p-datatable-tbody > tr > td {
        color: ${PRIMARY_FONT_COLOR};
        font-family: ${FONT_FAMILY_REGULAR};
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }

    .p-datatable .p-datatable-thead > tr > th:first-child,
    .p-datatable .p-datatable-tbody > tr > td:first-child {
        padding-left: 16px !important;
    }

    .p-datatable .p-datatable-thead > tr > th:last-child,
    .p-datatable .p-datatable-tbody > tr > td:last-child {
        padding-right: 16px !important;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        .p-datatable .p-datatable-thead > tr > th.consigned-batch-header,
        .p-datatable .p-datatable-thead > tr > th.consigned-on-hand-header,
        .p-datatable .p-datatable-thead > tr > th.consigned-use-by-date-header {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        .p-datatable .consigned-batch-header .p-column-title,
        .p-datatable .consigned-on-hand-header .p-column-title,
        .p-datatable .consigned-use-by-date-header .p-column-title {
            width: auto !important;
            white-space: nowrap;
            margin-right: 2px;
        }

        .p-datatable .consigned-on-hand-header .p-sortable-column-content {
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
            gap: 2px;
            white-space: nowrap;
        }

        .p-datatable .consigned-on-hand-header .p-column-title {
            margin-right: 0;
        }

        .p-datatable .consigned-batch-header .p-sortable-column-icon,
        .p-datatable .consigned-on-hand-header .p-sortable-column-icon,
        .p-datatable .consigned-use-by-date-header .p-sortable-column-icon {
            margin-left: 0 !important;
        }

        .p-datatable .p-datatable-tbody > tr > td.consigned-batch-body,
        .p-datatable .p-datatable-tbody > tr > td.consigned-on-hand-body,
        .p-datatable .p-datatable-tbody > tr > td.consigned-use-by-date-body {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        .p-datatable .consigned-use-by-date-body {
            overflow: hidden;
        }

        .p-datatable .consigned-use-by-date-body > div {
            min-width: 0;
            overflow: hidden;
        }

        .p-datatable .consigned-use-by-date-body .p-column-title,
        .p-datatable .consigned-use-by-date-body span {
            white-space: nowrap;
        }

        .p-datatable .consigned-on-hand-body > div{
            margin-left: -6px;
        }
        
    }

    @media (max-width: 1024px) {
        .p-datatable .p-paginator-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 100;
            margin: 0 !important;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
        }

        .p-datatable-wrapper {
            width: 100% !important;
            overflow-x: hidden;
            overflow-y: auto;
        }

        .p-datatable .p-datatable-scrollable-body {
            max-height: calc(100vh - 260px) !important;
        }
        #paginationInfo{
            margin-left: 10px;
        }
        .p-paginator.p-component{
            margin-right: 10px;
        }
    }
`;

export const PaginationContainer = styled.div`
    width: 100%;
    margin-top: 16px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    min-height: 48px !important;
`;

export const CellPrimaryText = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    line-height: 20px;
    overflow-wrap: break-word;
`;

export const DescriptionTooltipWrapper = styled.div`
    max-width: ${({ $maxLength }) => ($maxLength ? `${$maxLength}ch` : '100%')};

    #tooltip-text {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 0;
    }

    #tooltip-text span {
        display: inline-block;
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const AccountCell = styled(CellPrimaryText)`
    display: flex;
    flex-direction: row;
    gap: 4px;
    min-width: 0;

    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const AccountNumberText = styled.span`
    flex-shrink: 0;
`;

export const AccountNameText = styled.div`
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const UseByDateCell = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const ExpiredUseByDateIcon = styled.img`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`;

export const ExpiredUseByDateText = styled(CellPrimaryText)`
    color: #E40A1A;
`;

export const CellSecondaryText = styled.div`
    color: ${SECONDARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: 12px;
    line-height: 16px;
    overflow-wrap: break-word;
`;